module.exports = __webpack_public_path__ + "img/Reportes.ee8af7e4.png";